import React, { useEffect, useState, forwardRef } from 'react'
import {
  Dialog, DialogContent, Slide, Grid, Typography
} from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import { InterstitialZutoLogo } from '@zuto/icons'
import CheckedList from '../../CheckedList'
import { fireReactGAEvent } from '../../Questions/utils'
import AnimatedArrows from '../../Animations/AnimatedArrows'

const dialogStyles = {
  px: 0,
  textAlign: 'center',
  backgroundColor: '#fff',
  opacity: 1,
  boxShadow: 0,
  zIndex: '99999999999', /* Important so that Cookie Pro banner doesn't overlay */
  '.interstitial-header svg': {
    position: 'relative',
    transform: 'scale(0.90)'
  },
  '.MuiPaper-root': {
    margin: '0',
    width: '100%',
    padding: '30px 0',
    boxShadow: 0
  },
  '.MuiDialogContent-root': {
    maxWidth: '320px',
    margin: 'auto'
  }
}

const intEvent = (experiment:string, open:boolean) => {
  fireReactGAEvent({
    category: 'Application Form',
    action: open ? 'Interstitial Started' : 'Interstitial Ended',
    label: experiment
  })
}

const Transition = forwardRef((
  props: TransitionProps & {
    children: React.ReactElement<any, any>,
  },
  ref: React.Ref<unknown>
) => <Slide unmountOnExit direction="right" ref={ref} {...props} />)

type InterstitialProps = {
  experimentName: string
}

const PreInterstitialV1 = ({ experimentName }: InterstitialProps): JSX.Element => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setOpen(true)
    intEvent(experimentName, true)
  }, [])

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setOpen(false)
        intEvent(experimentName, false)
      }, 6000)
    }
  }, [open])

  const list = [
    'Confirm your details',
    'Submit for a new quote',
    'If approved, we\'ll call you'
  ]

  return (
    <Dialog
      open={open}
      data-testid="pre-interstitial-v1"
      TransitionComponent={Transition}
      keepMounted={false}
      aria-describedby="Pre Application Information"
      sx={dialogStyles}
      slotProps={{ backdrop: { style: { backgroundColor: 'rgba(255,255,255,1)' } } }}
      fullScreen
      fullWidth
    >
      <DialogContent sx={{ py: 12 }}>
        <Grid className="interstitial-header" direction="column" container spacing={1} columns={1} alignItems="center" justifyContent="center">
          <Grid><InterstitialZutoLogo data-testid="zuto-logo" /></Grid>
        <Typography variant="h3" color="#666" mt={4} mb={4}>Welcome back!</Typography>
        <Typography variant="body1" color="#666" mb={6}>Fetching your details...</Typography>
          <Grid><AnimatedArrows data-testid="animated-arrows" /></Grid>
        </Grid>
        <CheckedList list={list} />
      </DialogContent>
    </Dialog>
  )
}

export default PreInterstitialV1
